// Extension explicite (contrairement au reste du bundle) : ce module est aussi
// chargé tel quel par `node --test`, qui ne résout pas les imports sans extension.
import { roundTo } from "./odds_math.js"

// Miroir client de Blog::NumberFormat (app/services/blog/number_format.rb).
//
// Les deux implémentations doivent produire une chaîne strictement identique : le
// serveur rend l'exemple par défaut, le contrôleur Stimulus le réécrit à la
// première saisie. Un écart de formatage se verrait comme un « saut » de la valeur
// affichée, alors même que le calcul est bon.
//
// Deux choix explicites, partagés avec Rails :
// - aucun séparateur de milliers (Rails et Intl ne posent pas le même caractère) ;
// - la typographie des unités est décrite ici, pas déléguée à Intl, dont les tables
//   divergent de celles de rails-i18n.
// Échappée plutôt que littérale : une espace insécable est invisible à la relecture
// et se fait remplacer par une espace ordinaire au premier copier-coller.
export const NBSP = "\u00A0"
export const MINUS = "−"

// Miroir de Blog::NumberFormat::UNIT_LAYOUTS. L'anglais antépose le symbole
// monétaire (£ en `en`, $ en `en-us`) et colle le pourcentage au nombre ; les cinq
// marchés de la zone euro postposent le symbole € avec une espace insécable.
const englishLayout = (symbol) => ({ currency: (number) => `${symbol}${number}`, percent: (number) => `${number}%` })

const UNIT_LAYOUTS = { en: englishLayout("£"), "en-us": englishLayout("$") }

const DEFAULT_UNIT_LAYOUT = {
  currency: (number) => `${number}${NBSP}€`,
  percent: (number) => `${number}${NBSP}%`
}

export function formatValue(value, format, locale = "fr") {
  if (typeof value === "string") return value
  if (value === null || value === undefined || !Number.isFinite(value)) return "—"

  const digits = format === "american" ? 0 : 2
  const rounded = roundTo(value, digits)
  const layout = UNIT_LAYOUTS[locale] || DEFAULT_UNIT_LAYOUT
  const absolute = formatNumber(Math.abs(rounded), digits, locale)

  switch (format) {
    case "percent": return layout.percent(formatNumber(rounded, 2, locale))
    case "signed_percent": return sign(rounded) + layout.percent(absolute)
    case "currency": return layout.currency(formatNumber(rounded, 2, locale))
    case "signed_currency": return sign(rounded) + layout.currency(absolute)
    case "american": return sign(rounded) + absolute
    default: return formatNumber(rounded, 2, locale)
  }
}

function formatNumber(value, digits, locale) {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
    useGrouping: false
  }).format(value)
}

// Signe typographique « moins » (U+2212) comme côté Rails, pas le trait d'union.
function sign(value) {
  return value < 0 ? MINUS : "+"
}
